import { render, staticRenderFns } from "./Administracion-de-riesgos.vue?vue&type=template&id=4c237a6e&scoped=true&"
import script from "./Administracion-de-riesgos.vue?vue&type=script&lang=js&"
export * from "./Administracion-de-riesgos.vue?vue&type=script&lang=js&"
import style0 from "./Administracion-de-riesgos.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Administracion-de-riesgos.vue?vue&type=style&index=1&id=4c237a6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c237a6e",
  null
  
)

export default component.exports